// Badges and progress (UX02, XC02). Owner: WP04. Status is always text, never colour alone.
import type { ReactNode } from 'react';

export type BadgeTone = 'neutral' | 'live' | 'accent' | 'warn' | 'danger';
export function Badge({ tone = 'neutral', children, title }: { tone?: BadgeTone; children: ReactNode; title?: string }) {
  return <span className={`ui-badge ui-badge--${tone}`} title={title}>{children}</span>;
}

export function LiveBadge() {
  return <Badge tone="live">LIVE</Badge>;
}

/** XC02: a quality claim is labelled "provider reported" until playback verifies it. */
export function QualityBadge({ quality }: { quality: { value: string; provenance: 'provider_reported' | 'verified' } | null | undefined }) {
  if (!quality) return null;
  const reported = quality.provenance === 'provider_reported';
  return (
    <Badge title={reported ? 'Reported by your provider, not yet verified by Tuned' : 'Verified during playback'}>
      {quality.value}
      {reported ? <span className="ui-badge__note"> · provider reported</span> : null}
    </Badge>
  );
}

export type ProgressBarProps = {
  /** 0..1 */
  value: number;
  /** Accessible name, e.g. "Watched" or "Programme progress". */
  label: string;
  /** Visible text for assistive tech, e.g. "23 min left". */
  valueText?: string;
  className?: string;
};
export function ProgressBar({ value, label, valueText, className }: ProgressBarProps) {
  const pct = Math.round(Math.min(1, Math.max(0, value)) * 100);
  return (
    <div className={['ui-progress', className ?? ''].filter(Boolean).join(' ')} role="progressbar" aria-label={label} aria-valuemin={0} aria-valuemax={100} aria-valuenow={pct} aria-valuetext={valueText}>
      <div className="ui-progress__fill" style={{ width: `${pct}%` }} />
    </div>
  );
}
